import React, { useState } from "react";
import { FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import ModalVideo from "react-modal-video";
import Video from "./video.mp4"

const BannerTwo = () => {
  const [isOpen, setOpen] = useState(false);

  const partners = [
    {
      title: "Implementation Partner",
      logos: [
        { src: './assets/img/client/GOVERNMENT-LOGO.png', alt: '' },
       
      ]
    },
    {
      title: "Technical & Financial Partners",
      logos: [
        { src: './assets/img/client/FAO-LOGO.png', alt: '' },
        { src: './assets/img/client/Norway.png', alt: '' }
      ]
    },
    
    {
      title: "Development Partner",
      logos: [
        { src: './assets/img/client/DEVELOPED-by-GeoEDGE.png', alt: 'GeoEDGE' }
      ]
    }
  ];

  return (
    <>
      {/* ================== BannerTwo Start ==================*/}
      <div
        className='banner-area bg-relative banner-area-2 bg-cover'
        style={{ backgroundImage: 'url("./assets/img/bg/8.png")' }}
      >
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6 align-self-center'>
              <div className='banner-inner pe-xl-5'>
               
                <h2
                  className='title '
                  data-aos='fade-right'
                  data-aos-delay='200'
                  data-aos-duration='1500'
                >
                  {" "}
                  Transforming Fish Quality Assessment with <span>AI Precision</span> for Yellowfin Tuna
                </h2>
                <p
                  className='content pe-xl-5 '
                  data-aos='fade-right'
                  data-aos-delay='250'
                  data-aos-duration='1500'
                >
                 The "AI-MALUWA" App utilizes advanced scanning technology to evaluate key aspects of fish quality, including the eyes, skin, flesh and gills. Furthermore, a centralized database consolidates scanning results, location data, and quality metrics, providing a comprehensive approach to monitoring and managing fish quality. This ensures transparency and efficiency throughout the entire supply chain.
                </p>
               
                <div
                  className='d-inline-block align-self-center mt-5'
                  data-aos='fade-right'
                  data-aos-delay='350'
                  data-aos-duration='1500'
                >
                  <span
                    onClick={() => setOpen(true)}
                    className='video-play-btn-hover mt-5'
                  >
                    <img src='assets/img/video.svg' alt='img' />{" "}
                    <h6 className='d-inline-block'>How it Works</h6>
                  </span>

                  <div></div>
                </div>
                <ModalVideo
                  channel='custom'
                  url={Video}
                  autoplay
                  isOpen={isOpen}
                  videoId=''
                  onClose={() => setOpen(false)}
                />
              </div>
            </div>
            <div
              className='col-lg-6 col-md-9 '
              data-aos='fade-left'
              data-aos-delay='100'
              data-aos-duration='1500'
            >
              <div className='banner-thumb-2 mt-4 mt-lg-0'>
                <img
                  className='banner-animate-img banner-animate-img-4'
                  src='assets/img/banner-2/3.png'
                  alt='img'
                />
                <div className='main-img-wrap'>
                 
                  <img
                    className='main-img'
                    src='assets/img/banner-2/1.png'
                    alt='img'
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="logo-showcase">
      {partners.map((group, index) => (
        <div key={index} className="logo-group">
          <h5 className="logo-title">{group.title}</h5>
          <div className="logo-row">
            {group.logos.map((logo, idx) => (
              <img key={idx} src={logo.src} alt={logo.alt} className="logoc" />
            ))}
          </div>
        </div>
      ))}
    </div>
        </div>
      </div>

      {/* ================== BannerTwo End ==================*/}
    </>
  );
};

export default BannerTwo;
